<template>
  <div>
    <Timepicker :appointment="appointment" @request-save="onRequestSave" />
  </div>
</template>

<script setup lang="ts">
import Timepicker from "@/components/Seranova/Timepicker/Timepicker.vue";
import { AppointmentV2 } from "@/typings/appointment";

const emit = defineEmits(["request-save"]);
defineProps<{ appointment: AppointmentV2 }>();

const onRequestSave = (data: { action: string; payload: object }) => {
  emit("request-save", data);
};
</script>

<style scoped></style>
